import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchSavedFilters = createAsyncThunk('fetchSavedFilters', async (_, { getState, rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/saved-filters');
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch saved filters'));
  }
});

export const savedFilters = createSlice({
  name: 'savedFilters',
  initialState: {
    data: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSavedFilters.fulfilled, (state, action) => {
        state.data = action.payload.data;
      });
  }
});

export const getSavedFilters = (state) => state.savedFilters.data;

export { fetchSavedFilters };

export default savedFilters.reducer;
